<template>
  <div class="common-header __flex __flex-vc __flex-cb">
    <img :src="logo" class="img-logo" alt="" @click="toIndexPage()">
    <img src="@/assets/images/common/user.png" class="img-user" alt="" @click="show = true">
     <van-overlay :show="show" @click="show = false" >
       <div class="wrapper" @click.stop>
        <div class="block">
          <p class = "title">账号信息</p>
          <div class = "content">
            <p class = "left"> 用户姓名:</p>
            <p class = "right __line1"> {{user_name}}</p>
          </div>
          <div class = "content">
            <p class = "left"> 登录账号:</p>
            <p class = "right __line1"> {{login_name}}</p>
          </div>
          <div class = "content">
            <p class = "left"> 所属组织:</p>
            <p class = "right __line1"> {{org_name}}</p>
          </div>
          <div class="popup_but" @click.stop="signOut">
            <img class = "popup_exit" width="15px" height="15px" src="@/assets/images/home/nav-exit.png">
            <span>退出账号</span>
          </div>
        </div>
        </div>
     </van-overlay>
  </div>
</template>

<script>
import { common, aliyun } from '@/agent'
import LocalStorage from '@/utils/localStorage'
export default {
  name: 'CommonHeader',
  props: {},
  data () {
    return {
      show: false,
      org_name: '',
      user_name: '',
      login_name: '',
      logo: ''
    }
  },
  created () {
  },
  mounted () {
    this.init()
    this.getLogo()
  },
  methods: {
    // 初始化
    async init () {
      await this.GetUserInfo()
    },
    async GetUserInfo () {
      const result = await common.getCurrentUserInfo()
      this.org_name = result.data.data.orgName
      this.user_name = result.data.data.userName
      this.login_name = result.data.data.loginName
    },
    getLogo () {
      let param = {
        pageNum: 1,
        pageSize: 10,
        query: {}
      }
      common.findListByReceive(param).then(res => {
        if (res.code == 100) {
          this.logo = aliyun.getAliyunAddress(res.data.list[0].src)
        } else {
          this.logo = require('@/assets/images/common/logo.png')
        }
      })
    },
    showPopup () {
      this.show = true
    },
    signOut () {
      LocalStorage.clear()
      this.$router.replace('/login')
    },
    toIndexPage () {
      this.$router.push('/home')
    }
  },
}
</script>

<style scoped lang="scss">
.common-header {
  z-index: 10;
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 44px;
  padding: 0 20px;
  box-sizing: border-box;
  background-color: #fff;
  box-shadow: 0px 3px 18px 0px rgba(51, 51, 51, 0.25);
  .wrapper {
    .block {
      width: 200px;
      height: 215px;
      background: #ffffff;
      border-radius: 1px;
      opacity: 1;
      margin-top: 38px;
      margin-left: 155px;
      .title {
        opacity: 1;
        font-size: 17px;
        font-family: Source Han Sans CN, Source Han Sans CN-Regular;
        font-weight: 400;
        text-align: left;
        color: #666666;
        padding-top: 18px;
        padding-left: 21px;
        padding-bottom: 20px;
      }
      .content {
        width:163px;
        display: inline-flex;
        padding-left: 38px;
        height: 20px;
        line-height: 20px;
        margin-bottom: 12px;
        .left {
          opacity: 1;
          font-size: 12px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: left;
          color: #999999;
        }
        .right {
          padding-left: 16px;
          opacity: 1;
          font-size: 15px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: left;
          color: #666666;
        }
      }

      .popup_but{
        width: 142px;
        height: 32px;
        opacity: 1;
        background: #e50914;
        border-radius: 1px;
        display: inline-flex;
        margin: 8px 29px 0 29px;
        box-sizing: border-box;
        span{
          width: 100%;
          height: 15px;
          opacity: 1;
          font-size: 15px;
          font-family: Source Han Sans CN, Source Han Sans CN-Regular;
          font-weight: 400;
          text-align: left;
          color: #ffffff;
          padding-top:6px;
          padding-left:6px;
        }
        .popup_exit{
          opacity: 1;
          padding-left:32px;
          padding-top:9px;
          padding-bottom: 9px;
          z-index:20;
        }
      }
    }
  }
  .img-logo {
    width: 128px;
    height: 24px;
  }
  .img-user {
    width: 22px;
    height: 24px;
  }
}
</style>
